import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Bonafide Certificate - Simple Template with blank lines
 * Matches reference image (simple form format)
 */
export const BonafideTemplateSimple = ({ data }) => {
    const { school, student, details, issueDate, academicYear } = data;

    return (
        <Box sx={{
            fontFamily: '"Times New Roman", serif',
            fontSize: '12px',
            lineHeight: 1.6,
            color: '#000',
            backgroundColor: '#fff',
            p: 3,
            width: '210mm',
            minHeight: '148mm', // A5 height
            boxSizing: 'border-box',
            border: '2px solid #000',
            '@media print': {
                width: '210mm',
                margin: 0,
                padding: '15mm',
            }
        }}>
            {/* Header Section - Left aligned info */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Box>
                    <Typography sx={{ fontSize: 11 }}>No.</Typography>
                    <Typography sx={{ fontSize: 11, mt: 1 }}>Date of issue:</Typography>
                    <Typography sx={{ fontSize: 11 }}>____/____/20__</Typography>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                    <Typography sx={{ fontSize: 11 }}>
                        Name of the School: - Vidya Pratishthan's Supe English Medium School.
                    </Typography>
                    <Typography sx={{ fontSize: 11 }}>Gen.Reg.No.</Typography>
                </Box>
            </Box>

            {/* Certificate Title */}
            <Box sx={{ textAlign: 'center', my: 3 }}>
                <Typography sx={{
                    fontSize: 22, fontWeight: 'bold',
                    border: '2px solid #000', display: 'inline-block',
                    px: 3, py: 0.5, letterSpacing: 2
                }}>
                    BONAFIDE CERTIFICATE
                </Typography>
            </Box>

            {/* Left column labels */}
            <Box sx={{ display: 'flex', gap: 4 }}>
                <Box sx={{ width: '25%' }}>
                    <Typography sx={{ fontSize: 11, mb: 2 }}>Name of the Student:</Typography>
                    <Typography sx={{ fontSize: 11, mb: 2 }}>_______________</Typography>
                    <Typography sx={{ fontSize: 11, mb: 2 }}>Gen.Reg.No.</Typography>
                    <Typography sx={{ fontSize: 11, mb: 2 }}>Remarks</Typography>
                    <Typography sx={{ fontSize: 11, mb: 2 }}>_______________</Typography>
                    <Typography sx={{ fontSize: 11, mb: 2 }}>_______________</Typography>
                    <Typography sx={{ fontSize: 11, mt: 4 }}>H.M./Principal</Typography>
                </Box>

                {/* Right column content */}
                <Box sx={{ width: '75%', borderLeft: '1px dashed #000', pl: 3 }}>
                    <Typography sx={{ fontSize: 12, mb: 3 }}>
                        This is to Certify that Master /Miss_________________________________
                    </Typography>
                    <Typography sx={{ fontSize: 12, mb: 3, textAlign: 'right' }}>
                        _________________________________is/was a bonafide Student
                    </Typography>
                    <Typography sx={{ fontSize: 12, mb: 3 }}>
                        of this School Studying in Std___________________Div_______________
                    </Typography>
                    <Typography sx={{ fontSize: 12, mb: 3 }}>
                        He/She is ___________________________________________ by Caste
                    </Typography>
                    <Typography sx={{ fontSize: 12, mb: 3 }}>
                        His/Her date of Birth according to our Register is ____________________
                    </Typography>
                    <Typography sx={{ fontSize: 12, mb: 3 }}>
                        (In words ____________________________________________)
                    </Typography>
                    <Typography sx={{ fontSize: 12, mb: 4 }}>
                        He/She bears a good moral Character.
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
                        <Typography sx={{ fontSize: 11 }}>Date &nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;/20</Typography>
                        <Typography sx={{ fontSize: 11 }}>H.M./Principal</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default BonafideTemplateSimple;
